import { ReceptionServiceColorBar as InternalReceptionServiceColorBar } from './receptionServiceColorBar/ReceptionServiceColorBar';
import { ReceptionServicesDetails as InternalReceptionServicesDetails } from './receptionServicesDetails/ReceptionServicesDetails';
import { withReceptionServiceGuard } from './shared/withReceptionServiceGuard';

export const ReceptionServiceColorBar = withReceptionServiceGuard(InternalReceptionServiceColorBar);
export const ReceptionServicesDetails = withReceptionServiceGuard(InternalReceptionServicesDetails);
export { translations } from './translations';
export { withReceptionServiceGuard };
